/**
 * @generated SignedSource<<fffb39b6996d6367e6968de6ed7a37a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_RemovePricingMutation$variables = {
  pricingId: string;
  productIds: ReadonlyArray<number>;
};
export type productSidePanelContent_RemovePricingMutation$data = {
  readonly removeProductsFromPricing: {
    readonly result: boolean;
  };
};
export type productSidePanelContent_RemovePricingMutation = {
  response: productSidePanelContent_RemovePricingMutation$data;
  variables: productSidePanelContent_RemovePricingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pricingId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "pricingId",
        "variableName": "pricingId"
      },
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "removeProductsFromPricing",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_RemovePricingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "productSidePanelContent_RemovePricingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "380aaf3fa5bed5c2c712b2339cac603e",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_RemovePricingMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_RemovePricingMutation(\n  $pricingId: ID!\n  $productIds: [Long!]!\n) {\n  removeProductsFromPricing(pricingId: $pricingId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b1a53b73df5528c848b4461c5132064";

export default node;
